import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { logoutConnectedUser } from '../../user/userUtils';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { NavUserDecision } from './components/NavUserDecision';
import { NavUserLawyer } from './components/NavUserLawyer';
import { useUser } from '../../user/useUser';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { canSeeDocumentsComparison } from '../../../../shared/paying-options/canAccessDocumentsComparison';
import {
  NavUserDropdownLink,
  NavUserDropdownHyperlink,
} from './components/NavUserDropdownLink';
import styles from './nav_user_dropdown.module.scss';

type Props = {
  showNav: boolean;
};

const dropdownAnalytics = (source: string) => () => {
  doctrineAnalytics('Nav DropdownItemClicked', { id: source });
};

export const NavUserDropdown: FC<Props> = ({ showNav }) => {
  const {
    currentUser: { lawyerId, plan, payingOptions, featureFlags },
  } = useUser();
  const userLogout = () => {
    logoutConnectedUser();
  };

  const source = 'nav_dropdown';

  const displayDocumentAnalyzerComparison = canSeeDocumentsComparison(
    plan,
    payingOptions,
    featureFlags,
    true,
  );

  return (
    <div
      className={classNames(styles.container, {
        [styles.show]: showNav,
      })}
    >
      <NavUserLawyer />
      <ul
        className={classNames(styles.list, {
          [styles.space]: !lawyerId,
        })}
      >
        <li>
          <NavUserDropdownLink
            to={buildUrlWithParameters('/', {
              source,
            })}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/7" />
          </NavUserDropdownLink>
        </li>
        <li className={styles.da}>
          <NavUserDropdownHyperlink href="/document-analyzer" source={source}>
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/6" />
          </NavUserDropdownHyperlink>
        </li>

        {displayDocumentAnalyzerComparison && (
          <li className={styles.da}>
            <NavUserDropdownHyperlink
              href="/document-analyzer/comparison"
              source={source}
            >
              <FormattedMessage id="navigation/user/NavUserDropdown.tsx/8" />
            </NavUserDropdownHyperlink>
          </li>
        )}
        <li className={styles.folders}>
          <NavUserDropdownLink
            to={buildUrlWithParameters('/dossiers', {
              source,
            })}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/1" />
          </NavUserDropdownLink>
        </li>
        <NavUserDecision />
        <li>
          <NavUserDropdownLink
            to={buildUrlWithParameters('/historique_recherches', {
              source,
            })}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/2" />
          </NavUserDropdownLink>
        </li>
        <li>
          <NavUserDropdownHyperlink href="https://nouveautes.doctrine.fr/">
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/9" />
          </NavUserDropdownHyperlink>
        </li>
        <li>
          <NavUserDropdownHyperlink
            href="/aide"
            source={source}
            target="_blank"
            onClick={dropdownAnalytics('help-center')}
          >
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/3" />
          </NavUserDropdownHyperlink>
        </li>
        <li>
          <hr className={styles.separator} />
        </li>
        <li>
          <NavUserDropdownHyperlink href="/account" source={source}>
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/4" />
          </NavUserDropdownHyperlink>
        </li>

        <li>
          <NavUserDropdownHyperlink name="logout-link" onClick={userLogout}>
            <FormattedMessage id="navigation/user/NavUserDropdown.tsx/5" />
          </NavUserDropdownHyperlink>
        </li>
      </ul>
    </div>
  );
};
